import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./style.scss";
import SidebarSearch from "../../components/SidebarSearch";
import api from "../../api";

const QUESTIONS_TAB_ID = "__questions__";

export default function Categories({
  onCategorySelect,
  selectedCategory,
  onSearch,
  onFilterChange,
}) {
  const location = useLocation();
  const isFeedPage = location.pathname === "/feed";
  const [categories, setCategories] = useState([]);
  const [searchTerms, setSearchTerms] = useState({});

  // 🔹 Filter states (NEW)
  const [activeFilter, setActiveFilter] = useState("new");
  const [showFilters, setShowFilters] = useState(false);

  useEffect(() => {
    onFilterChange?.(activeFilter);
  }, [activeFilter, onFilterChange]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await api.get("/topics");
        const topics = res.data?.topics || [];
        setCategories(topics);
      } catch (err) {
        console.error(
          "Failed to load categories:",
          err.response?.data || err.message
        );
      }
    };
    fetchCategories();
  }, []);

  // 🔹 update search term
  const handleSearchChange = (value) => {
    if (!selectedCategory) return;
    setSearchTerms((prev) => ({
      ...prev,
      [selectedCategory]: value
    }));
  };

  // 🔹 when press Enter
  const handleSearchSubmit = (value) => {
    if (onSearch) {
      onSearch(value, selectedCategory, activeFilter);
    }
  };

  // 🔹 clear search for this category
  const handleClear = () => {
    if (!selectedCategory) return;
    setSearchTerms((prev) => ({
      ...prev,
      [selectedCategory]: ""
    }));
    if (onSearch) {
      onSearch("", selectedCategory, activeFilter);
    }
  };

  return (
    <>
    <aside className="sidebar-left-main">
      {/* 🔹 FILTER TOGGLE SECTION */}
      <div className="filter-section d-none">

        {/* Filter button and dropdown Mobile-view*/}
        {/* <div className="filter-mode">
  <button className="filter-items actives" >
    Read Mode
  </button>
   <button className="filter-items">
    Watch
  </button>
</div> */}



        <button
          className="filter-btn"
          onClick={() => setShowFilters((prev) => !prev)}
        >
          <img src="/images/filter.png" alt="Filter Icon" className="filter-icon" />
          <span className="filter-text">
            {activeFilter === "top" ? "Top" : activeFilter === "controversial" ? "Controversial" : "New"}
          </span>
        </button>

        {showFilters && (
          <ul className="filter-list">
            <li
              className={`filter-item ${activeFilter === "new" ? "active" : ""
                }`}
              onClick={() => {
                setActiveFilter("new");
                setShowFilters(false);
              }}
            >
              New
            </li>

            <li
              className={`filter-item ${activeFilter === "top" ? "active" : ""
                }`}
              onClick={() => {
                setActiveFilter("top");
                setShowFilters(false);
              }}
            >
              Top
            </li>

            <li
              className={`filter-item ${activeFilter === "controversial" ? "active" : ""
                }`}
              onClick={() => {
                setActiveFilter("controversial");
                setShowFilters(false);
              }}
            >
              Controversial
            </li>
          </ul>
        )}
      </div>

      {/* 🔹 CATEGORY LIST */}
      <ul className="category-list">
        <li
          className={`category-item ${selectedCategory === null ? "active-item" : ""}`}
          onClick={() => onCategorySelect && onCategorySelect(null)}
          style={{ cursor: "pointer" }}
        >
          <span className="cat-label">{isFeedPage ? "Confessions" : "Discover"}</span>
        </li>
        {!isFeedPage && (
          <li
            className={`category-item ${selectedCategory === QUESTIONS_TAB_ID ? "active-item" : ""}`}
            onClick={() => onCategorySelect && onCategorySelect(QUESTIONS_TAB_ID)}
            style={{ cursor: "pointer" }}
          >
            <span className="cat-label">
              Confessions
            </span>
          </li>
        )}
        {categories.length > 0 ? (

          categories.map((cat) => (
            <li
              key={cat.id}
              className={`category-item ${selectedCategory === cat.id ? "active-item" : ""
                }`}
              onClick={() =>
                onCategorySelect && onCategorySelect(cat.id)
              }
              style={{ cursor: "pointer" }}
            >
              <span className="cat-label">{cat.name}</span>
            </li>
          ))
        ) : (
          <li className="category-item">
            <span className="cat-label">No Category Listed</span>
          </li>
        )}
      </ul>

     
    </aside>
     {/* 🔹 SEARCH PER CATEGORY - only show for non-Discover categories */}
      {selectedCategory !== null && selectedCategory && selectedCategory !== QUESTIONS_TAB_ID && (
        <SidebarSearch
          searchTerm={searchTerms[selectedCategory] || ""}
          onSearchChange={handleSearchChange}
          onSearchSubmit={handleSearchSubmit}
          onClear={handleClear}
          placeholder={`Search in ${categories.find((c) => c.id === selectedCategory)?.name ||
            "topic"
            }...`}
        />
      )}
      </>
  );
}
